export default __webpack_public_path__ + "static/media/HeroSVG1.c2ea26b9.png";